import { render, staticRenderFns } from "./chage-audio-player.vue?vue&type=template&id=c56821da&scoped=true&"
import script from "./chage-audio-player.vue?vue&type=script&lang=js&"
export * from "./chage-audio-player.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56821da",
  null
  
)

export default component.exports